import React from "react";

const MapAreas = () => {
  const plotCoordinates = [
  { id: "plot-h1", coords: "1161,1179, 1159,1374, 1050,1378, 1041,1410, 1429,1399, 1470,1149", alt: "plot-h1" },
  { id: "plot-h2", coords: "1037,1414, 954,1564, 1397,1556, 1432,1404", alt: "plot-h2" },
  { id: "plot-h3", coords: "947,1570,928,1617, 990,1720, 1367,1718, 1393,1563", alt: "plot-h3" },
  { id: "plot-h4", coords: "988,1728, 966,1893, 1331,1898, 1365,1724", alt: "plot-h4" },
  { id: "plot-h5", coords: "958,1898, 934,2074, 1303,2070, 1333,1907", alt: "plot-h5" },
  { id: "plot-h6", coords: "930,2081,919,2147, 857,2250, 1271,2252, 1301,2079", alt: "plot-h6" },
  { id: "plot-h7", coords: "857,2251,793,2361, 825,2401, 1245,2401, 1269,2258", alt: "plot-h7" },
  { id: "plot-h9", coords: "1018,2662, 1071,2943, 1110,3011, 1213,3003, 1161,2690", alt: "plot-h9" },
  { id: "plot-h10", coords: "1166,2692, 1217,2998, 1361,2985,1339,2724", alt: "plot-h10" },
  { id: "plot-h11", coords: "1344,2728, 1361,2988, 1554,2966, 1543,2765", alt: "plot-h11" },
  { id: "plot-h12", coords: "1297,2484, 1260,2662, 1567,2722, 1624,2518", alt: "plot-h12" },
  { id: "plot-h13", coords: "1333,2301, 1297,2477, 1624,2511, 1676,2316", alt: "plot-h13" },
  { id: "plot-h14", coords: "1365,2120,1335,2300, 1682,2311, 1723,2124", alt: "plot-h14" },
  { id: "plot-h15", coords: "1397,1942,1369,2116, 1732,2122, 1764,1940", alt: "plot-h15" },
  { id: "plot-h16", coords: "1427,1762, 1402,1937, 1768,1940, 1802,1766", alt: "plot-h16" },
  { id: "plot-h17", coords: "1462,1579,1429,1757, 1805,1760, 1841,1584", alt: "plot-h17" },
  { id: "plot-h18", coords: "1496,1405,1466,1573, 1843,1575, 1880,1410", alt: "plot-h18" },
  { id: "plot-h19", coords: "1541,1141,1498,1398, 1877,1407, 1937,1109", alt: "plot-h19" }
];


  return (
    <map name="projectMap">
      {plotCoordinates.map((plot) => (
        <area
          key={plot.id}
          shape="poly"
          coords={plot.coords}
          href="#"
          alt={plot.alt}
          data-key={plot.id}
        />
      ))}
    </map>
  );
};

export default MapAreas;